import type { RunQueryResponse } from '@/api/rpc/hooks/procurement/useRunQuery';
import type { ReportDataset } from '@/components/report-canvas/ReportDataContext';

export const QUERY_BUILDER_DATASET_KEY = 'query-result';

/**
 * Adapts a query-builder run result into the report canvas's dataset shape.
 * The query builder is a single-dataset surface: every chart reads this one.
 */
export function runQueryResponseToDatasets(
  result: RunQueryResponse | null,
): ReportDataset[] {
  if (!result) return [];
  return [
    {
      key: QUERY_BUILDER_DATASET_KEY,
      label: 'Query result',
      columns: result.columns,
      rows: result.rows,
    },
  ];
}
